import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.middle');
import { OnInit, NgZone, ChangeDetectorRef } from '@angular/core';

interface FileItem {
  name: string;
  status: '대기' | '완료';
  selected: boolean;
}

@Component({
    selector: 'wiz-component-middle',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.middle/view.scss */
/* src/app/component.middle/view.scss: no such file or directory */`],
})
export class ComponentMiddleComponent implements OnInit {
  files: FileItem[] = [];
  completedFiles: FileItem[] = [];

  constructor(@Inject( NgZone) private zone: NgZone,@Inject( ChangeDetectorRef)  private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {}

  onFileSelect(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;

    const pdfFiles = Array.from(input.files).filter(f => f.type === 'application/pdf');
    if (pdfFiles.length === 0) {
      alert('PDF 파일만 업로드할 수 있습니다.');
      return;
    }

    this.zone.run(() => {
      const newFiles = pdfFiles
        .filter(f => !this.files.some(existing => existing.name === f.name))
        .map(f => ({ name: f.name, status: '대기', selected: false }));

      this.files = [...this.files, ...newFiles];
      console.log('📂 업로드된 파일:', this.files);
      this.cdr.detectChanges();
    });

    setTimeout(() => { input.value = ''; }, 0);
  }

  get selectedCount(): number {
    return this.files.filter(f => f.selected).length;
  }

  startEmbedding(): void {
    const selectedFiles = this.files.filter(f => f.selected);
    if (selectedFiles.length === 0) {
      alert('임베딩할 파일을 선택해주세요.');
      return;
    }

    this.zone.run(() => {
      selectedFiles.forEach(file => (file.status = '완료'));
      const newlyCompleted = selectedFiles.filter(
        f => !this.completedFiles.some(c => c.name === f.name)
      );

      this.completedFiles = [...this.completedFiles, ...newlyCompleted];

      console.log('✅ 임베딩 완료된 파일:', this.completedFiles);
      this.cdr.detectChanges();
    });
  }
}

export default ComponentMiddleComponent;